<div [formGroup]="formGroup" *ngIf="transport != null">
  <mat-radio-group formControlName="planningType">
    <sc-flex vertical stretchContent>
      <mat-radio-button [value]="TransportPlanningType.DEFAULT">
        <sc-dictionary-label dictionaryKey="tmc-yard.common.enum.transport-planning-type.DEFAULT"></sc-dictionary-label>
      </mat-radio-button>
      <mat-radio-button [value]="TransportPlanningType.TIMEFRAME">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.common.enum.transport-planning-type.TIMEFRAME"></sc-dictionary-label>
      </mat-radio-button>
      <div *ngIf="transport.timing.planningType === TransportPlanningType.TIMEFRAME">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-date-time-field-legacy formControlName="timeSlotDate" [label]="'TIMEFRAME' |
    translate:['tmc-yard.common.enum.transport-planning-type.TIMEFRAME',
    translationService.language, translationService.revision]" style="width: 100%;"></sc-date-time-field-legacy>
      </div>
      <mat-radio-button [value]="TransportPlanningType.IN_ADVANCE">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.common.enum.transport-planning-type.IN_ADVANCE"></sc-dictionary-label>
      </mat-radio-button>
      <div *ngIf="transport.timing.planningType === TransportPlanningType.IN_ADVANCE">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-date-field-legacy formControlName="inAdvanceDate" labelDictionaryKey="tmc-yard.common.enum.transport-planning-type.IN_ADVANCE" style="width: 100%;"></sc-date-field-legacy>
      </div>
    </sc-flex>
  </mat-radio-group>

</div>
